import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
// style
import './index.css';
// component
import App from 'App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
